// @flow

import { abroadClient } from 'frame/net/clientFactory'

function toLoginPage () {
  window.location.href =
    '/gblwx/hw/login?rd=' + encodeURIComponent(window.location.href)
}

export function get (path: string, query?: { [string]: string }): Promise<*> {
  return abroadClient.get(path, query).catch(e => {
    if (e.code === 102) {
      toLoginPage()
    }
    throw e
  })
}

export function postJson (path: string, body: mixed): Promise<*> {
  return abroadClient.postJson(path, body).catch(e => {
    if (e.code === 102) {
      toLoginPage()
    }
    throw e
  })
}



// WEBPACK FOOTER //
// ./src/projects/abroad/lib/apiClient.js